import React from 'react';
import { EligibilityStatus } from 'services/intelligentShoppingExperience/types';

const ShopByListContext = React.createContext<EligibilityStatus | null>(null);

export default ShopByListContext;
